import { useId, type ReactNode } from 'react';

import type { ArticleMedia } from './types';

const CAROUSEL_ID_PREFIX = 'img-carousel';

export const getSlideHref = ({ index, href }: { index: number; href: string }) =>
  index === 0 ? href : `${href}?image=${index}`;

export const isVideo = (item: ArticleMedia) => Boolean(item.ytId);

export interface PaginationProps {
  goToSlide: (slide: number) => void;
  slideCount: number;
  currentSlide: number;
  paginationContainerStyles?: any;
}

export type ImageCarouselRenderPaginationFn<TProps extends PaginationProps> = (
  props: TProps
) => ReactNode;

/**
 * per-instance ID prefix for a carousel.
 * – A page can render many <ImageCarousel> components.
 * – Each carousel creates elements (slides, dots, …) that reference each other via `id` / `aria-controls`.
 * – These IDs must be unique in the whole DOM to satisfy the accessibility spec and to avoid collisions when React re-orders nodes.
 */
export const useCarouselId = () => {
  const uniqueId = useId();

  return `${CAROUSEL_ID_PREFIX}-${uniqueId}`;
};
